import React, { FC } from 'react';
import { Input, InputNumber, Radio, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Form from '~/components/WizardForm';
import buildNamePath from '~/utils/buildNamePath';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';
import { useGetPayloadWithProvided } from '~/controllers/wizard';

const n = buildNamePath('companyQuestionnaire');

const textareaAutoSize = { minRows: 2 };

const CompanyInformationInputs: FC = () => {
  const { t } = useTranslation('ksaApplication');

  const payload = useGetPayloadWithProvided();

  if (!payload) return null;

  const providedWebsiteUrl = payload?.thiqahFullInfo?.address?.general?.website;

  return (
    <Container>
      <InputsGroupLayout>
        <Form.Item
          name={n(['companyInformation', 'websiteUrl'])}
          label={t('Company website URL')}
          disabled={!!providedWebsiteUrl}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={n(['companyInformation', 'numberOfEmployees'])}
          label={t('Number of employees')}
        >
          <InputNumber />
        </Form.Item>
      </InputsGroupLayout>
      <Typography.Title level={5}>
        {t('The reason for applying for payment services')}
      </Typography.Title>
      <Form.Item name={n(['companyInformation', 'purposeOfThePaymentGateway'])}>
        <Input.TextArea autoSize={textareaAutoSize} />
      </Form.Item>
      <Typography.Title level={5}>{t('Do you have any established branch?')}</Typography.Title>
      <Form.Item name={n(['companyInformation', 'hasEstablishedBranch'])}>
        <Radio.Group className="CompanyInformationInputs-EstablishedBranchRadio">
          <Radio value>{t('Yes')}</Radio>
          <Radio value={false}>{t('No')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Visible name={n(['companyInformation', 'hasEstablishedBranch'])}>
        <Typography.Title level={5}>
          {t('Please specify the countries and the locations of your branches')}
        </Typography.Title>
        <Form.Item name={n(['companyInformation', 'branchesInformation'])}>
          <Input.TextArea autoSize={textareaAutoSize} />
        </Form.Item>
      </Form.Visible>
      <Typography.Title level={5}>{t('Do you require tokenization?')}</Typography.Title>
      <Form.Item name={n(['companyInformation', 'requireTokenization'])}>
        <Radio.Group className="CompanyInformationInputs-RequireTokenizationRadio">
          <Radio value>{t('Yes')}</Radio>
          <Radio value={false}>{t('No')}</Radio>
        </Radio.Group>
      </Form.Item>
    </Container>
  );
};

const Container = styled.div`
  .CompanyInformationInputs-EstablishedBranchRadio {
    margin-top: -16px;
    margin-bottom: 8px;
  }
`;

export default CompanyInformationInputs;
